import type { GetToastsQuery, PushToastMutationVariables } from '@generated/gql';
import GET_TOASTS from '../graphql/getToasts';
import type { Resolvers } from '../types';

export const toastResolvers: Resolvers = {
  Mutation: {
    pushToast: (_, variables: PushToastMutationVariables, { cache }) => {
      const data = cache.readQuery<GetToastsQuery>({ query: GET_TOASTS });

      let toasts = data?.toasts || [];
      if (!toasts.some((toast) => toast?.message === variables.toast.message)) {
        toasts = [...toasts, variables.toast];
      }

      cache.writeQuery({ query: GET_TOASTS, data: { toasts } });
    },

    popToast: (_, __, { cache }) => {
      const data = cache.readQuery<GetToastsQuery>({ query: GET_TOASTS });
      const toasts = data?.toasts ? data?.toasts.slice(1) : [];
      cache.writeQuery({ query: GET_TOASTS, data: { toasts } });
    },
  },
};
